module.exports = __webpack_public_path__ + "img/removed.0827f46e.svg";